import { delay } from './misc'

const MIN_DELAY_MS = 3000
const MAX_DELAY_MS = 10000
const SHORT_TEXT_THRESHOLD = 20
const LONG_TEXT_THRESHOLD = 100
const DELAY_INCREMENT_PER_CHARS = 20
const DELAY_INCREMENT_MS = 2500

export const calculateMessageDelay = (text: string): number => {
  if (!text) {
    return MIN_DELAY_MS
  }

  const textLength = text.trim().length

  if (textLength <= SHORT_TEXT_THRESHOLD) {
    return MIN_DELAY_MS
  }

  if (textLength >= LONG_TEXT_THRESHOLD) {
    return MAX_DELAY_MS
  }

  return Math.min(
    MAX_DELAY_MS,
    MIN_DELAY_MS +
      Math.floor(textLength / DELAY_INCREMENT_PER_CHARS) * DELAY_INCREMENT_MS,
  )
}

export const delayMessageSend = (text = ''): Promise<unknown> => {
  const delayCounter = calculateMessageDelay(text)

  return delay(delayCounter)
}
